<template>
  <div class="card form-detail">
    <div class="card-header d-flex" style="justify-content: space-between">
      <h3>{{ title }}</h3>
      <a href="javascript:;" @click="action.onClick" v-if="action && action.active !== false">{{
        action.text
      }}</a>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      action: Object,
    },
    name: 'Card',

    components: {},

    data: () => {
      return {}
    },

    methods: {},
  }
</script>
